import React from "react";
import { BetQLSportItem } from "src/common-services";

import TrendPopover from "../../TrendPopover";
import { renderRating } from "../../../../services/ValueDataService";
import { TrackingProperties } from "../../../../constants";
import { UpgradeToView } from "../../RowComponents";
import { SubscriptionContext } from "../../../../services/SubscriptionService";

/**
 * Render the rating cell
 *
 * @param game The game to get the date from
 * @param index The index for the key
 * @param ourPick Which team to highlight
 * @param filterKey The bet type to determine which line to show
 * @param isNew Whether we should use a the power rating or old trends
 * @param trackingProps The tracking properties to include with the analytics event
 */
export const getRatingCell = (
  game: any,
  index: number,
  ourPick: "home" | "away" | "draw",
  filterKey: string,
  isNew: boolean,
  trackingProps: TrackingProperties,
  currentSportObj: BetQLSportItem,
  showDraw: boolean
) => {
  const periodFilter =
    filterKey === "spread" || filterKey === "moneyline" || filterKey === "total" ? `FG${filterKey}` : filterKey;
  const noAwayLine = game[`current${periodFilter}AwayDisplay`] === "--";
  const noHomeLine = game[`current${periodFilter}HomeDisplay`] === "--";
  const hasCurrentLine = !noAwayLine && !noHomeLine;

  return (
    <React.Fragment key={index}>
      <SubscriptionContext.Consumer>
        {({ hasSubscriptionAccess }) => {
          const hasAccess = hasSubscriptionAccess(currentSportObj.key);
          return game.freeGame || hasAccess ? (
            <div
              className={`games-table-column__value-rating-cell ${
                showDraw ? "games-table-column__value-rating-cell--draw" : ""
              }`}
            >
              <div className="games-table-column__rating-container">
                {ourPick === "away" ? (
                  <React.Fragment>
                    <button className="games-table-column__rating-button" id={`rating-popover-${index}1`} type="button">
                      {renderRating(game[`max${isNew ? "New" : ""}${periodFilter}Trend`], false, "", hasCurrentLine)}
                      See Bet Analysis
                    </button>
                    <TrendPopover
                      sportKey={currentSportObj.key}
                      game={game}
                      target={`rating-popover-${index}1`}
                      isNew={isNew}
                      filterKey={filterKey}
                      trackingProps={trackingProps}
                    />
                  </React.Fragment>
                ) : null}
              </div>
              <div className="games-table-column__rating-container">
                {ourPick === "home" ? (
                  <React.Fragment>
                    <button className="games-table-column__rating-button" id={`rating-popover-${index}2`} type="button">
                      {renderRating(game[`max${isNew ? "New" : ""}${periodFilter}Trend`], false, "", hasCurrentLine)}
                      See Bet Analysis
                    </button>
                    <TrendPopover
                      sportKey={currentSportObj.key}
                      game={game}
                      target={`rating-popover-${index}2`}
                      isNew={isNew}
                      filterKey={filterKey}
                      trackingProps={trackingProps}
                    />
                  </React.Fragment>
                ) : null}
              </div>
              {showDraw ? (
                <div className="games-table-column__rating-container">
                  {ourPick === "draw" ? (
                    <React.Fragment>
                      <button
                        className="games-table-column__rating-button"
                        id={`rating-popover-${index}3`}
                        type="button"
                      >
                        {renderRating(game[`max${isNew ? "New" : ""}${periodFilter}Trend`], false, "", hasCurrentLine)}
                        See Bet Analysis
                      </button>
                      <TrendPopover
                        sportKey={currentSportObj.key}
                        game={game}
                        target={`rating-popover-${index}3`}
                        isNew={isNew}
                        filterKey={filterKey}
                        trackingProps={trackingProps}
                      />
                    </React.Fragment>
                  ) : null}
                </div>
              ) : null}
            </div>
          ) : (
            <UpgradeToView
              key={index}
              className={`games-table-column__value-rating-cell ${
                showDraw ? "games-table-column__value-rating-cell--draw" : ""
              }`}
              showText={true}
              trackingProps={{
                screen: "FeedView",
                page: "Games Table",
                source: "Rating Cell",
                sport: currentSportObj.key,
                gameId: game.id,
                awayTeam: game.awayTeam.fullName,
                homeTeam: game.homeTeam.fullName,
              }}
            />
          );
        }}
      </SubscriptionContext.Consumer>
    </React.Fragment>
  );
};
